export const googleAuthScript = "https://accounts.google.com/gsi/client";
export const appleAuthScript = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

export const hubspotMeetingScript = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
